export default __webpack_public_path__ + "static/media/pricing-image-07.e5ec7ef0.png";